import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { checkPermission } from '../helpers/checkPermission';
import useCurrentUser from '../hooks/useCurrentUser';
import ErrorFallback from './ErrorFallback/ErrorFallback';
import Loader from './Loader/Loader';

/**
 *
 * @param {RouteProps} props
 * @returns
 */
function AccessibleAfterAuth(props) {
  const {
    component: Component, render, permissions, ...rest
  } = props;

  const {
    data: user, isLoading, isError, refetch,
  } = useCurrentUser();

  return (
    <Route
      {...rest}
      render={(renderProps) => {
        if (isError) return <ErrorFallback onRetry={() => refetch()} />;
        if (isLoading) return <Loader size="large" />;
        if (user && checkPermission(user.roles, permissions)) {
          if (Component) return <Component {...renderProps} />;
          return render(renderProps);
        }
        return <Redirect to="/" />;
      }}
    />
  );
}

/**
 *
 * @param {RouteProps} props
 * @returns
 */
function AccessibleBeforeAuth(props) {
  const { component: Component, render, ...rest } = props;
  const {
    data: user, isLoading, isError, refetch,
  } = useCurrentUser();
  return (
    <Route
      {...rest}
      render={(renderProps) => {
        if (isError) return <ErrorFallback onRetry={() => refetch()} />;
        if (isLoading) return <Loader size="large" />;
        if (user) return <Redirect to="/home" />;
        if (Component) return <Component {...renderProps} />;
        return render(renderProps);
      }}
    />
  );
}

const CustomRoutes = { AccessibleAfterAuth, AccessibleBeforeAuth };

export default CustomRoutes;
